import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import defaultProfileAvatar from '../../assets/images/default-profile-avatar.svg';
import {
  FaTachometerAlt,
  FaUserInjured,
  FaNotesMedical,
  FaCalendarAlt,
  FaUserCircle,
  FaSignOutAlt
} from 'react-icons/fa';
import './DokterLayout.css';

const DokterLayout = ({ title, children }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation(); // Digunakan untuk mendeteksi menu aktif
  
  // 1. STATE UNTUK DETEKSI MOBILE / DESKTOP
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const userName = String(user?.nama || user?.name || 'Dokter');
  const photoSrc = user?.photo_url
    ? `${user.photo_url}${user.photo_url.includes('?') ? '&' : '?'}v=${user.photo_version || 0}`
    : defaultProfileAvatar;

  const handleLogout = () => {
    logout();
    navigate('/login', { replace: true });
  };

  // Helper untuk menambahkan class 'active' pada menu yang sedang dibuka
  const isActive = (path) => location.pathname === path ? 'active' : '';

  return (
    <div className={`dokter-layout ${isMobile ? 'mobile-mode' : 'desktop-mode'}`}>
      
      {/* 2. SIDEBAR HANYA MUNCUL DI DESKTOP (!isMobile) */}
      {!isMobile && (
        <aside className="dokter-sidebar">
          <div className="sidebar-header">
            <div className="sidebar-header-brand">
              <img src={photoSrc} alt="Profil Dokter" className="sidebar-header-avatar" />
              <h3>Dokter</h3>
            </div>
          </div>

          <nav className="sidebar-nav">
            <ul>
              <li>
                <Link to="/dokter" className={`sidebar-link ${isActive('/dokter')}`}>
                  <FaTachometerAlt /> Dashboard
                </Link>
              </li>
              <li>
                <Link to="/dokter/antrian" className={`sidebar-link ${isActive('/dokter/antrian')}`}>
                  <FaUserInjured /> Antrian
                </Link>
              </li>
              <li>
                <Link to="/dokter/diagnosis" className={`sidebar-link ${isActive('/dokter/diagnosis')}`}>
                  <FaNotesMedical /> Diagnosis
                </Link>
              </li>
              <li>
                <Link to="/dokter/jadwal" className={`sidebar-link ${isActive('/dokter/jadwal')}`}>
                  <FaCalendarAlt /> Jadwal
                </Link>
              </li>
            </ul>
          </nav>

          <div className="sidebar-footer">
            <button
              className="user-info user-profile-btn"
              onClick={() => navigate('/dokter/profile')}
              title="Profile"
              style={{ display: 'flex', alignItems: 'center', width: '100%' }}
            >
              <p style={{ margin: 0, fontSize: '13px', color: '#000000', fontWeight: '500' }}>{userName}</p>
              <span style={{ fontSize: '11px', color: '#64748b', marginLeft: 'auto', whiteSpace: 'nowrap' }}>
                Profile
              </span>
            </button>
            <button className="logout-btn" onClick={handleLogout}>
              <FaSignOutAlt style={{ marginRight: 6 }} />
              Logout
            </button>
          </div>
        </aside>
      )}

      {/* AREA KONTEN UTAMA */}
      <main className="dokter-content">
        {title && (
          <div className="dokter-page-header">
            <h1>{title}</h1>
            {/* Tombol logout cepat khusus versi mobile diletakkan di kanan atas header */}
            {isMobile && (
              <button className="mobile-logout-btn" onClick={handleLogout} title="Logout">
                <FaSignOutAlt />
              </button>
            )}
          </div>
        )}
        <div className="content-body">
          {children}
        </div>
      </main>

      {/* 3. MOBILE BOTTOM NAVIGATION HANYA MUNCUL DI MOBILE (isMobile) */}
      {isMobile && (
        <nav className="mobile-bottom-nav">
          <Link to="/dokter" className={`bottom-nav-link ${isActive('/dokter')}`}>
            <FaTachometerAlt />
            <span>Dashboard</span>
          </Link>
          <Link to="/dokter/antrian" className={`bottom-nav-link ${isActive('/dokter/antrian')}`}>
            <FaUserInjured />
            <span>Antrian</span>
          </Link>
          <Link to="/dokter/diagnosis" className={`bottom-nav-link ${isActive('/dokter/diagnosis')}`}>
            <FaNotesMedical />
            <span>Diagnosis</span>
          </Link>
          <Link to="/dokter/jadwal" className={`bottom-nav-link ${isActive('/dokter/jadwal')}`}>
            <FaCalendarAlt />
            <span>Jadwal</span>
          </Link>
          <Link to="/dokter/profile" className={`bottom-nav-link ${isActive('/dokter/profile')}`}>
            <FaUserCircle />
            <span>Profile</span>
          </Link>
        </nav>
      )}

    </div>
  );
};

export default DokterLayout;